import {affiliatePortalRoutes} from './affiliatePortal'
import {agencyDashboardRoutes} from './dashboard'
import {agencyLaunchpadRoutes} from './launchpad'
import {aiEmployeePromoRoutes, aiAgentsContestRoutes} from './aiEmployeePromo'
import {ghlSwagRoutes} from './ghlSwag'
import {ideasRoutes} from './ideas'
import {integrationRoutes} from './integration'
import {marketplaceRoutes} from './marketplace'
import {mobileAppCustomiserRoutes} from './mobileAppCustomiser'
import {partnersRoutes} from './partners'
import {prospectingRoutes} from './prospecting'
import {resellingRoutes} from './reselling'
import {saasRoutes} from './saas'
import {settingsRoutes} from './settings'
import {snapshotsRoutes} from './snapshots'
import {subAccountRoutes} from './subAccounts'
import {templateLibraryAdminRoutes} from './templateLibraryAdmin'
import {universityRoutes} from './university'

export {
  affiliatePortalRoutes,
  agencyDashboardRoutes,
  ideasRoutes,
  integrationRoutes,
  marketplaceRoutes,
  mobileAppCustomiserRoutes,
  partnersRoutes,
  prospectingRoutes,
  resellingRoutes,
  saasRoutes,
  settingsRoutes,
  snapshotsRoutes,
  subAccountRoutes,
  templateLibraryAdminRoutes,
  universityRoutes,
  ghlSwagRoutes,
  aiEmployeePromoRoutes,
  aiAgentsContestRoutes,
  agencyLaunchpadRoutes,
}
